<template>
    <div class="multiselect-wrapper">
        <Multiselect
            :placeholder="
                value.length
                    ? $t('reporting.commonLabels.callTypes')
                    : $t('reporting.commonLabels.allCallTypes')
            "
            :multiple="true"
            :close-on-select="false"
            :options="callTypes"
            label="name"
            track-by="name"
            :value="selectedCallTypes"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            @input="updateCallTypes"
        >
            <span slot="noResult">{{ $t('common.noSearchResults') }}</span>
        </Multiselect>
    </div>
</template>

<script>
import Multiselect from 'moxa-vue-multiselect';
import { mapState } from 'vuex';

export default {
    components: { Multiselect },

    props: {
        value: {
            type: Array,
            required: true,
        },
    },

    computed: {
        ...mapState(['callTypes']),

        /**
         * Returns a list of currently selected call_types for Multiselect component
         * @return {{ id: number, name: string }[]}
         */
        selectedCallTypes() {
            return this.callTypes.filter(callType => this.value.includes(callType.id));
        },
    },

    methods: {
        /**
         * Emits update event for "call_types" field in widget configuration
         * @param {{ id: number, name: string }[]} selectedCallTypes
         */
        updateCallTypes(selectedCallTypes) {
            this.$emit(
                'input',
                selectedCallTypes.map(v => v.id)
            );
        },
    },
};
</script>
